import React, { memo, useContext, useState } from 'react';
import Popover from '../../../../lib/popover';
import { FuncType } from '../../button/enum';
import { Size } from '../../core/enum';
import Button from '../../button/Button';
import Tooltip from '../../tooltip';
import TableContext from '../TableContext';
import { $l } from '../../locale-context';
import CustomizationSettings from './CustomizationSettings';
const ComboCustomizationColumnHeader = function ComboCustomizationColumnHeader() {
    const { prefixCls } = useContext(TableContext);
    const [visible, setVisible] = useState(false);
    const handleVisibleChange = () => {
        setVisible(!visible);
    };
    return (React.createElement(Tooltip, { title: $l('Table', 'field_settings') },
        React.createElement(Popover, { trigger: "click", placement: "bottomRight", overlayClassName: `${prefixCls}-combo-customization`, title: $l('Table', 'field_settings'), content: React.createElement(CustomizationSettings, { visible: visible, setVisible: setVisible }), onVisibleChange: handleVisibleChange, visible: visible, arrowPointAtCenter: true },
            React.createElement(Button, { funcType: FuncType.flat, size: Size.small, icon: "predefine" }))));
};
ComboCustomizationColumnHeader.displayName = 'ComboCustomizationColumnHeader';
export default memo(ComboCustomizationColumnHeader);
